export default __webpack_public_path__ + "static/media/logo.568cb17b.svg";